import { Container, Form, Row } from "react-bootstrap";
import MarginCalculatorHeader from "../components/MarginCalculatorHeader";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCalculator, faFileLines} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import * as userSelectors from "../../../selectors/user";
import { useCallback, useEffect, useState } from "react";
import ProfitAndLossSetting from "../components/ProfitAndLossSetting";
import ProfitAndLossResult from "../components/ProfitAndLossResult";
import { withTransactionCostConfig } from "../../../hooks/withTransactionCostConfig";
import * as toolSelectors from "../../../selectors/tool";
import _ from "lodash";
function ProfitAndLossCalculator({ configData }) {
  const [values, setValues] = useState({
    brokerage_under_rate: toolSelectors.getConfigBrokerageUnderRateValue(configData),
    brokerage_over_rate: toolSelectors.getConfigBrokerageOverRateValue(configData),
    min_brokerage: toolSelectors.getConfigMinBrokerageValue(configData),
    is_warrant: false,
    no_of_shares: "0",
    buy_price: "0",
    sell_price: "0",
  });
  const [resultValues, setResultValues] = useState(null);
  const userState = useSelector((state) => state.user);
  const accountSelections = userSelectors.getUserAccountIsSelectedText(userState);
  const clientName = userSelectors.getUserName(userState);

  useEffect(() => {
    setValues({
      brokerage_under_rate: toolSelectors.getConfigBrokerageUnderRateValue(configData),
      brokerage_over_rate: toolSelectors.getConfigBrokerageOverRateValue(configData),
      min_brokerage: toolSelectors.getConfigMinBrokerageValue(configData),
      is_warrant: false,
      no_of_shares: "0",
      buy_price: "0",
      sell_price: "0",
    });
  }, [configData]);

  const onChangeValues = (field, value) => {
    setValues((prev) => {
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const calculateNow = useCallback(() => {
    var no_shares = parseFloat(values.no_of_shares);
    var buy_price = parseFloat(values.buy_price);
    var sell_price = parseFloat(values.sell_price);
    var is_warrant = values.is_warrant;
    var brokerageUnderRate = values.brokerage_under_rate;
    var brokerageOverRate = values.brokerage_over_rate;
    var minBrokerage = values.min_brokerage;
    if (isNaN(no_shares)) {
      // alert("No of shares is empty.");
      return;
    }

    if (isNaN(buy_price)) {
      // alert("Buy price is empty.");
      return;
    }

    if (isNaN(sell_price)) {
      // alert("Sell price is empty.");
      return;
    }

    const buy_gross_amount = parseFloat(buy_price * (no_shares * 100));
    const sell_gross_amount = parseFloat(sell_price * (no_shares * 100));

    //** Buy & Sell After Brokerage Fee **/
    const calculatedBuyValue =
      buy_gross_amount <= 100000
        ? buy_gross_amount * (brokerageUnderRate / 100)
        : buy_gross_amount * (brokerageOverRate / 100);
    const calculatedSellValue =
      sell_gross_amount <= 100000
        ? sell_gross_amount * (brokerageUnderRate / 100)
        : sell_gross_amount * (brokerageOverRate / 100);

    //** Buy & Sell Brokerage Fee **/
    const buy_brokerage =
      calculatedBuyValue < toolSelectors.getConfigMinBrokerageValue(configData)
        ? parseFloat(minBrokerage)
        : parseFloat(calculatedBuyValue);
    const sell_brokerage =
      calculatedSellValue < toolSelectors.getConfigMinBrokerageValue(configData)
        ? parseFloat(minBrokerage)
        : parseFloat(calculatedSellValue);

    //** Buy & Sell Clearing Fee **/
    const buy_clearing_fee = parseFloat(
      buy_gross_amount * (toolSelectors.getConfigClearingFeeValue(configData) / 100),
    );
    const sell_clearing_fee = parseFloat(
      sell_gross_amount * (toolSelectors.getConfigClearingFeeValue(configData) / 100),
    );

    let stampDuty = 0;
    let stampDutyMax = 0;

    if (is_warrant) {
      stampDuty = toolSelectors.getConfigStampDutyWarrantValue(configData);
      stampDutyMax = toolSelectors.getConfigMaxStampDutyWarrantValue(configData);
    } else {
      stampDuty = toolSelectors.getConfigStampDutyValue(configData);
      stampDutyMax = toolSelectors.getConfigMaxStampDutyValue(configData);
    }

    //** Buy & Sell Stamp Duty Fee **/
    // let buy_stamp_duty = Helpers.roundToDecimals(buy_gross_amount * stampDuty);
    // buy_stamp_duty = buy_stamp_duty > stampDutyMax ? stampDutyMax : Math.ceil(buy_stamp_duty);
    let stamp_duty_charge_per1000 = stampDuty * 10;
    let buy_stamp_duty = buy_gross_amount / 1000;

    buy_stamp_duty =
      buy_stamp_duty % 1 === 0
        ? parseInt(buy_stamp_duty) * stamp_duty_charge_per1000
        : parseInt(buy_stamp_duty) * stamp_duty_charge_per1000 + stamp_duty_charge_per1000;

    buy_stamp_duty = buy_stamp_duty > stampDutyMax ? stampDutyMax : buy_stamp_duty;

    // let sell_stamp_duty = Helpers.roundToDecimals(sell_gross_amount * stampDuty);
    // sell_stamp_duty = sell_stamp_duty > stampDutyMax ? stampDutyMax : Math.ceil(sell_stamp_duty);
    let sell_stamp_duty = sell_gross_amount / 1000;
    sell_stamp_duty =
      sell_stamp_duty % 1 === 0
        ? parseInt(sell_stamp_duty) * stamp_duty_charge_per1000
        : parseInt(sell_stamp_duty) * stamp_duty_charge_per1000 + stamp_duty_charge_per1000;
    sell_stamp_duty = sell_stamp_duty > stampDutyMax ? stampDutyMax : sell_stamp_duty;

    const buy_total_charges = parseFloat(buy_brokerage + buy_clearing_fee + buy_stamp_duty);
    const sell_total_charges = parseFloat(sell_brokerage + sell_clearing_fee + sell_stamp_duty);
    const buy_sst_charge = parseFloat(buy_brokerage * toolSelectors.getConfigSSTValue(configData));
    const sell_sst_charge = parseFloat(sell_brokerage * toolSelectors.getConfigSSTValue(configData));

    const buy_net_amount = parseFloat(buy_total_charges + buy_gross_amount + buy_sst_charge);
    const sell_net_amount = parseFloat(sell_gross_amount - sell_total_charges - sell_sst_charge);

    const net_profit = sell_net_amount - buy_net_amount;
    const net_profit_percentage = sell_net_amount / buy_net_amount - 1;

    const breakeven_price = Math.round(
      parseFloat(buy_total_charges * 2) / parseFloat(no_shares) + parseFloat(buy_price),
      3,
    );

    if (isNaN(net_profit) || isNaN(net_profit_percentage) || isNaN(breakeven_price)) {
      return;
    } else {
      setResultValues((prev) => {
        return {
          ...prev,
          buy_share_text: (Math.round(no_shares * 100) / 100).toFixed(0),
          sell_share_text: (Math.round(no_shares * 100) / 100).toFixed(0),
          buy_share_price: buy_price.toFixed(5),
          sell_share_price: sell_price.toFixed(5),
          buy_gross_amount: (Math.round(buy_gross_amount * 100) / 100).toFixed(2),
          sell_gross_amount: (Math.round(sell_gross_amount * 100) / 100).toFixed(2),
          buy_brokerage: (Math.round(buy_brokerage * 100) / 100).toFixed(2),
          sell_brokerage: (Math.round(sell_brokerage * 100) / 100).toFixed(2),
          buy_clearing_fee: (Math.round(buy_clearing_fee * 100) / 100).toFixed(2),
          sell_clearing_fee: (Math.round(sell_clearing_fee * 100) / 100).toFixed(2),
          buy_stamp_duty: (Math.round(buy_stamp_duty * 100) / 100).toFixed(2),
          sell_stamp_duty: (Math.round(sell_stamp_duty * 100) / 100).toFixed(2),
          buy_total_charges: (Math.round(buy_total_charges * 100) / 100).toFixed(2),
          sell_total_charges: (Math.round(sell_total_charges * 100) / 100).toFixed(2),
          buy_sst_charges: (Math.round(buy_sst_charge * 100) / 100).toFixed(2),
          sell_sst_charges: (Math.round(sell_sst_charge * 100) / 100).toFixed(2),
          buy_net_amount: (Math.round(buy_net_amount * 100) / 100).toFixed(2),
          sell_net_amount: (Math.round(sell_net_amount * 100) / 100).toFixed(2),
          net_profit: (Math.round(net_profit * 100) / 100).toFixed(2),
        };
      });
    }
  }, [values]);

  useEffect(() => {
    if (!_.isEmpty(values)) {
      calculateNow();
    }
  }, [values]);

  const onClickReset = () => {
    setValues({
      brokerage_under_rate: toolSelectors.getConfigBrokerageUnderRateValue(configData),
      brokerage_over_rate: toolSelectors.getConfigBrokerageOverRateValue(configData),
      min_brokerage: toolSelectors.getConfigMinBrokerageValue(configData),
      is_warrant: false,
      no_of_shares: "0",
      buy_price: "0",
      sell_price: "0",
    });
  };

  const onClickIntraDay = () => {
    setValues({
      ...values,
      brokerage_over_rate: toolSelectors.getConfigIntraDayRateValue(configData),
      brokerage_under_rate: toolSelectors.getConfigIntraDayRateValue(configData),
    });
  };

  return (
      <Container fluid>
        <div className={"primary-border-table-border"} style={{backgroundColor: "white"}}>
          <div className={clsx("d-flex custom-card-label-container align-items-center")}>
            <FontAwesomeIcon
                icon={faCalculator}
                className="fa-2x"
                style={{marginRight: "10px", color: "white"}}
            />
            <h2>Profit & Loss Calculator</h2>
          </div>
          <div className={clsx("custom-table-info-container padding-12px")}>
            <Row>
              <ProfitAndLossSetting
                  onClickReset={onClickReset}
                  onClickIntraDay={onClickIntraDay}
                  onChangeValues={onChangeValues}
                  values={values}
              ></ProfitAndLossSetting>
              <ProfitAndLossResult values={resultValues}></ProfitAndLossResult>
            </Row>
          </div>
        </div>
      </Container>
  );
}

export default withTransactionCostConfig(ProfitAndLossCalculator);
